<template>
  <b-sidebar
    id="sidebar-right-task"
    right
    backdrop
    backdrop-variant="dark"
    no-close-on-route-change
    no-close-on-backdrop
    no-header
    body-class="p-0"
    lazy
    :width="width"
    @hidden="closeTaskSidebar"
  >
    <template #default="{ hide }">
      <div class="detail-widget__top">
        <b-icon-arrow-bar-left
          class="detail-widget__back cursor-pointer"
          font-scale="2"
          @click="hide"
        />
      </div>

      <div class="container-fluid d-flex flex-column h-100 p-4">
        <div class="row mb-3">
          <div class="col-md-12">
            <div class="task-flex-title">
              <template v-if="task.creator_user_id != currentUser.id">
                <div class="modal--title">
                  <span>{{ task.title }}</span>
                </div>
              </template>
              <template v-else>
                <input
                  ref="title"
                  type="text"
                  class="form-control"
                  v-model="task.title"
                  @blur="updateTaskField"
                >
              </template>
            </div>
            <div class="text-secondary task-flex-column">
              <button
                class="task-copy-button"
                @click="copyLink"
              >
                <b-icon
                  icon="link45deg"
                  scale="1"
                ></b-icon>
              </button>
              <template v-if="task.creator_user_id === currentUser.id">
                <div class="mr-1">
                  <span>{{ '#' + task.id + ': ' }} статус назначенной задачи</span>
                </div>
              </template>
              <template v-else>
                <div class="mr-1">
                  <span>{{ '#' + task.id + ': ' }} в колонке</span>
                </div>
              </template>
              <b-dropdown
                size="sm"
                variant="select_column"
                no-caret
                ref="dropdownWithStatus"
              >
                <template #button-content>
                  <u v-html="handlerTaskStatus(task.reference_status_id)"></u>
                </template>
                <div class="px-2">
                  <div>
                    <span class="modal--task_subtitle">Выберите статус</span>
                    <b-form-select
                      v-model="task.reference_status_id"
                      :options="options"
                    />
                  </div>
                  <div class="mt-3 text-right">
                    <button class="btn btn-sm btn-secondary" @click="moveTaskInColumn">Сохранить</button>
                  </div>
                </div>
              </b-dropdown>
            </div>
          </div>
        </div>
        <div class="row pb-3 px-3">
          <div class="col-md-8 p-0">
            <div>
              <span class="modal--task_subtitle mb-1">Исполнители</span>
              <div class="task-flex-realizators">
                <div v-for="realizator in task.realizators" :key="realizator.id">
                  <template v-if="realizator.avatar_path">
                    <img :src="realizator.avatar_path" class="mr-1" style="width:32px;border-radius:32px">
                  </template>
                  <template v-else>
                    <b-avatar
                      :size="32"
                      :text="nameAvatar(realizator.name)"
                      class="cursor-pointer mr-1"
                      :title="realizator.name"
                    />
                  </template>
                </div>
                <template v-if="task.creator_user_id == currentUser.id">
                  <div>
                    <b-dropdown
                      size="sm"
                      variant="task"
                      dropright
                      no-caret
                      @hide="addNewRealizators"
                    >
                      <template #button-content>
                        <b-icon icon="plus" scale="1.7" class="text-secondary"></b-icon>
                      </template>
                      <b-dropdown-header class="modal--task_subtitle text-center">
                        Добавить исполнителя
                      </b-dropdown-header>
                      <b-dropdown-divider></b-dropdown-divider>
                      <div class="px-2">
                        <tsoft-select-user
                          id="realizator-task"
                          :roles="`sales-manager||sales-head-manager||logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager||TO-manager||TO-head-manager||administrator||bsz-manager||b2c-head-manager||b2c-manager||lawyer-manager||lawyer-head-manager||hr-manager||hr-head-manager||agent`"
                          :needNullElement="false"
                          :selectedArray="selectedPerformers"
                          :needMultipleSelect="true"
                          :customClass="'multiselect_task'"
                          @set="setRealizatorUserId"
                        />
                      </div>
                      <div class="text-left px-2">
                        <small><b class="text-danger">*</b>чтобы сохранить закройте окно выбора</small>
                      </div>
                    </b-dropdown>
                  </div>
                  <div>
                  </div>
                </template>
              </div>
            </div>
            <div class="task-flex-description mt-3">
              <div class="mr-2">
                <b-icon icon="text-left" scale="1.3"></b-icon>
              </div>
              <div>
                <span class="text-brown font-weight-bold font-size-16">Описание</span>
              </div>
            </div>
            <div>
              <template v-if="task.creator_user_id != currentUser.id">
                <div class="modal_description">
                  <div class="ml-4">{{ task.description ? task.description : 'Комментарий к задаче не оставлялся...' }}</div>
                </div>
              </template>
              <template v-else>
                <textarea
                  class="form-control modal--textarea_description"
                  cols="10"
                  rows="6"
                  v-model="task.description"
                  placeholder="Добавьте подробное описание задачи..."
                  @change="updateTaskField"
                />

                <div class="text-right position-relative">
                  <b-button
                    title="Прикрепить файлы"
                    @click="checkedLoadDocument = !checkedLoadDocument"
                    :variant="checkedLoadDocument ? 'success' : 'secondary'"
                    class="task-fly-add-files-button"
                  >
                    <b-icon icon="cloud-upload" aria-hidden="true"></b-icon> Добавить
                  </b-button>
                </div>
              </template>

              <tsoft-show-edit-documents
                :taskId="task.id"
                :requestDocuments="task.id ? true : false"
                :updateListDocument="singleOrMultiDocuments"
                :noActions="task.creator_user_id != currentUser.id"
                @clearDocumentList="clearDocumentList"
              />

              <tsoft-create-documents
                v-if="checkedLoadDocument && task.creator_user_id == currentUser.id"
                :taskId="task.id"
                :needMultiUploadDocuments="true"
                :onlyMultiUploadDocuments="true"
                @updateViewDocument="documentOutput"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="task-flex-creator mb-4">
              <div class="task-creator_info mb-1">
                <span class="modal--task_subtitle">Автор задачи</span>
              </div>
              <div v-if="task.creator">
                <template v-if="task.creator.avatar_path">
                  <img :src="task.creator.avatar_path" class="mr-1" style="width:32px;border-radius:32px">
                </template>
                <template v-else>
                  <b-avatar :size="32" :text="nameAvatar(task.creator.name)" class="mr-1"></b-avatar>
                </template>
                <span class="text-brown">{{ task.creator.name }}</span>
              </div>
            </div>
            <div class="mb-4">
              <div class="mb-1">
                <span class="modal--task_subtitle">Метки</span>
              </div>
              <div class="task-flex-tags mt-2">
                <div :class="`task-tags ${handlerStyleTags(task)}`">
                  <span v-html="handlerTypeTaskTag(task)"></span>
                </div>
                <div class="task-tags-act ml-2">
                  <span :class="`text-secondary`" v-html="handlerTypeReferenceId(task.reference_type_id)"></span>
                </div>
              </div>
            </div>
            <div class="mb-4">
              <div class="mb-1">
                <span class="modal--task_subtitle">Срок</span>
              </div>
              <div class="task-realization_at">
                <b-icon icon="calendar2-date" scale="0.8" class="ml-1 mr-2" />
                <span>{{ task.realization_at | formattedDateTime }}</span>
                <template v-if="task.creator_user_id == currentUser.id">
                  <b-dropdown
                    size="sm"
                    variant="task-edit"
                    no-caret
                    class="float-right"
                    dropleft
                    @hide="updateTaskField"
                  >
                    <template #button-content>
                      Изменить
                    </template>
                    <b-dropdown-header class="modal--task_subtitle text-center">
                      Изменить дату/время
                    </b-dropdown-header>
                    <b-dropdown-divider />
                    <div class="px-2">
                      <input type="datetime-local" class="form-control" v-model="task.realization_at">
                    </div>
                    <div class="text-left px-2">
                      <small class="no-wrap"><b class="text-danger">*</b>чтобы сохранить закройте окно выбора</small>
                    </div>
                  </b-dropdown>
                </template>
              </div>
            </div>
            <div>
              <div>
                <span class="modal--task_subtitle">Данные по задаче</span>
              </div>
              <div class="mb-2">
                <b-dropdown
                  size="sm"
                  variant="button_task"
                  no-caret
                >
                  <template #button-content>
                    <b-icon icon="people" scale="0.8" class="ml-1 mr-2"></b-icon> Исполнители
                  </template>
                  <b-dropdown-header class="modal--task_subtitle text-center">
                    Исполнители
                  </b-dropdown-header>
                  <b-dropdown-divider />
                  <div class="px-2">
                    <div class="pb-2"  v-for="(realizator, index) in task.realizators" :key="index">
                      <template v-if="realizator.avatar_path">
                        <img :src="realizator.avatar_path" class="mr-1" style="width:25px;border-radius:25px">
                      </template>
                      <template v-else>
                        <b-avatar :size="25" :text="nameAvatar(realizator.name)" class="mr-1"></b-avatar>
                      </template>
                      <span class="text-brown mr-1">{{realizator.name}}</span>
                      <template v-if="task.creator_user_id == currentUser.id">
                        <span
                          @click="deleteRealizators(index, realizator.pivot.id)"
                          class="float-right cursor-pointer font-size-12 text-secondary"
                        >
                          <i class="fas fa-trash"></i>
                        </span>
                      </template>
                    </div>
                  </div>
                </b-dropdown>
                <!-- ВРЕМЕННО ОТКЛЮЧЕНО -->
                <!-- <div class="button_task">
                    <span><b-icon icon="tags" class="ml-1 mr-2"></b-icon> Метки</span>
                </div> -->
              </div>
              <div :class="task.order_id || task.company_id || task.finance_id ? 'task-realization_at' : ''">
                <ul class="font-size-12 mb-0">
                  <template v-if="task.order_id">
                    <li v-if="task.order">Заказ: <span class="float-right font-weight-bold">#{{ task.order.id }}</span></li>
                    <li v-if="task.order.company">Клиент: <span class="float-right font-weight-bold">{{ task.order.company.name }}</span></li>
                    <li v-if="task.order.company">Тип клиента: <span class="float-right font-weight-bold">{{ task.order.company.status.name }}</span></li>
                  </template>
                  <template v-if="task.finance_id">
                    <li>Номер счета: <span class="float-right font-weight-bold">{{ task.finance.invoice_number ? task.finance.invoice_number : '-' }}</span></li>
                  </template>
                  <template v-if="task.company_id">
                    <li>Компания: <span class="float-right font-weight-bold">{{ task.company.name }}</span></li>
                    <li>Инн: <span class="float-right font-weight-bold">{{ task.company.inn }}</span></li>
                    <div class="mt-2">
                      <span 
                        class="font-weight-bold text-uppercase text-orange font-size-16"
                        @click="openCompanySidebar(task.company_id)"
                        style="cursor: pointer;"
                      >Перейти к клиенту&nbsp;
                        <i class="far fa-arrow-alt-circle-right"></i>
                      </span>                
                    </div>
                  </template>
                  <template v-else-if="task.order && task.order.temp_name">
                    <li>Компания: <span class="float-right font-weight-bold">{{ task.order.temp_name }}</span></li>
                  </template>
                </ul>
                <template v-if="task.order_id">
                  <div class="mt-2">
                    <span 
                      class="font-weight-bold text-uppercase text-orange font-size-16"
                      @click="openOrderSidebar(task.order_id)"
                      style="cursor: pointer;"
                    >Перейти к заказу&nbsp;
                      <i class="far fa-arrow-alt-circle-right"></i>
                    </span>                
                  </div>
                  <div v-if="task.order && task.order.company">
                    <span 
                      class="font-weight-bold text-uppercase text-orange font-size-16"
                      @click="openCompanySidebar(task.order.company.id)"
                      style="cursor: pointer;"
                    >Посмотреть клиента&nbsp;
                      <i class="far fa-arrow-alt-circle-right"></i>
                    </span>                
                  </div>
                </template>
                <template v-if="task.finance_id">
                  <div class="mt-2">
                    <span 
                      class="font-weight-bold text-uppercase text-orange font-size-16"
                      @click="openFinanceSidebar(task.finance_id)"
                      style="cursor: pointer;"
                    >Перейти к счету&nbsp;
                      <i class="far fa-arrow-alt-circle-right"></i>
                    </span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="border-top pt-2 row">
          <div class="col text-right">
            <span class="text-secondary">Задача создана {{ task.created_at | formattedDateTime }}</span>
          </div>
        </div>
        <TaskComments :task-id="+$route.query.task" class="mb-0 mt-auto" />
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { API_TASKS, API_USER_TASKS } from '@/constants';
import TaskComments from '@components/task/TaskComments';

import { defaultDataItems, mixinTasks } from '@/mixins';
import { openOrderSidebar } from '@/mixins/openOrderSidebar';
import { openFinanceSidebar } from '@/mixins/openFinanceSidebar';
import { openCompanySidebar } from '@/mixins/openCompanySidebar';
import { mixinDocuments } from '@/mixins/mixinDocuments';
import { copyLink } from '@/mixins';

export default {
  components: {TaskComments},
  props: {
    width: { type: String, require: true }
  },

  mixins: [
    defaultDataItems,
    mixinTasks,
    mixinDocuments,
    openFinanceSidebar,
    openCompanySidebar,
    openOrderSidebar,
    copyLink,
  ],

  data() {
    return {
      realizatorData: {},
      selectedPerformers: '',
      options: [
        { value: '400', text: 'На выполнение' },
        { value: '401', text: 'В работе' },
        { value: '402', text: 'На проверке' },
        { value: '403', text: 'Выполнено' }
      ],
      selectColumn: {
        reference_status_id: ''
      },
      checkedLoadDocument: false,
      task: {}
    }
  },

  computed: {
    ...mapGetters('auth', ['currentUser'])
  },

  methods: {
    getTask() {
      api.call('get', `${API_TASKS}/${this.$route.query.task}`)
        .then(({data}) => {
          this.task = data;
      })
    },
    getRealizatorsData() {
      for (let item in this.task.realizators) {
        if (this.currentUser.id === this.task.realizators[item].pivot.realizator_user_id) {
          this.realizatorData = this.task.realizators[item].pivot
        }
      }
    },
    addNewRealizators() {
      let selectedUser = {
        task_id: this.task.id,
        realizator_user_id: this.selectedPerformers,
      };

      if (this.isUserInArr(this.task.realizators, selectedUser)) {
        api.call('post', API_USER_TASKS, { realizators: [selectedUser]})
          .then(({data}) => {
            this.$set(this.task, 'realizators', data.realizators);
            this.makeToast('success', 'Задача обновлена');
            this.SET_EDITTING_TASK(this.task);
        })
      }
    },
    isUserInArr(arr, user) {
      if (arr.length) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id === user.realizator_user_id) {
              return false;
          }
        }
      }
      return true;
    },
    deleteRealizators(index, id) {
      api.call('delete', `${API_USER_TASKS}/${id}`)
        .then(() => {
          this.task.realizators.splice(index, 1)
          this.makeToast('success', 'Задача обновлена');
          this.SET_EDITTING_TASK(this.task);
      })
    },
    updateTaskField() {
      api.call('put', `${API_TASKS}/${this.task.id}`, this.task)
        .then(({data}) => {
          this.makeToast('success', 'Задача обновлена');
          this.SET_EDITTING_TASK(this.task);
        })
    },
    handlerTaskStatus(status = null) {
      if (status) {
        if (status == 400) {return 'К выполнению'}
        if (status == 401) {return 'В работе'}
        if (status == 402) {return 'На проверке'}
        if (status == 403) {return 'Выполнено'}
      } else {
        if (this.realizatorData.reference_status_id == 400) {return 'К выполнению'}
        if (this.realizatorData.reference_status_id == 401) {return 'В работе'}
        if (this.realizatorData.reference_status_id == 402) {return 'На проверке'}
        if (this.realizatorData.reference_status_id == 403) {return 'Выполнено'}
      }
    },
    moveTaskInColumn() {
      api.call('put', `${API_TASKS}/${this.task.id}`, { reference_status_id: this.task.reference_status_id }).then(({data}) => {
        this.task.reference_status_id = data.reference_status_id;
        this.selectColumn.reference_status_id = this.task.reference_status_id;
        this.$refs.dropdownWithStatus.hide(true);
        this.SET_EDITTING_TASK(this.task);
      })
    },
    setRealizatorUserId(id) {
      this.selectedPerformers = id[0]
    },
    closeTaskSidebar() {
      const query = Object.assign({}, this.$route.query);
      delete query.task;
      this.$router.replace({ query });
    },
    ...mapMutations('task', ['SET_EDITTING_TASK']),
  },

  mounted () {
    this.getTask();
    this.getRealizatorsData();
  },
}
</script>

<style scoped>
.task-fly-add-files-button {
  position: absolute;
  right: 15px;
  top: 32px;
  z-index: 10;
}
.detail-widget__top {
  position: relative;
  color: #fff;
  background-color: #0d6247;
  padding: 15px 1.5rem 15px 3rem;
  min-height: 60px;
}

.detail-widget__back {
  font-size: 200%;
  position: absolute;
  left: 10px;
  top: 15px;
}

.task-copy-button {
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  margin-right: 2px;
  padding: 0;
  border: none;
  outline: none;
  background-color: transparent;
  color: #5a6268;
}

</style>